export default __webpack_public_path__ + "static/media/featured_tour_04.c573e741.png";